import React, { useState } from "react";
import ServiceProvidersList from "./components/ServiceProvidersList/ServiceProvidersList";
import AddServiceProvider from "./components/AddServiceProvider/AddServiceProvider";
import { MainLayout } from "../../components/MainLayout";
import { useTranslation } from "react-i18next";
import "./ServiceProvider.styles.scss";

const ServiceProvider = ({
  tab,
  serviceProviders,
  taxpayerActivities,
  taxpayerSearch,
  onAddServiceProvider,
  onSearchHandler,
  onTaxpayerSearchChange,
  loading,
}) => {
  const [showForm, setShowForm] = useState(false);
  const { t } = useTranslation();

  const handleCancel = () => {
    setShowForm(false);
  };

  const handleAddSuccess = () => {
    setShowForm(false);
  };

  return (
    <MainLayout tab={tab} withSidebar={true}>
      <div className="service_provider_section">
        <h2 className="section_title">Service Provider Management</h2>

        <div className="d-flex justify-content-between align-items-center mb-4">
          {!showForm && (
            <button
              onClick={() => setShowForm(true)}
              className="btn btn-primary"
            >
              <span>Add New</span>
            </button>
          )}
        </div>

        {showForm && (
          <AddServiceProvider
            taxpayerActivities={taxpayerActivities}
            taxpayerSearch={taxpayerSearch}
            onAddServiceProvider={onAddServiceProvider}
            onTaxpayerSearchChange={onTaxpayerSearchChange}
            handleCancel={handleCancel}
            handleAddSuccess={handleAddSuccess}
            loading={loading}
          />
        )}

        <ServiceProvidersList
          serviceProviders={serviceProviders}
          onSearchHandler={onSearchHandler}
        />
      </div>
    </MainLayout>
  );
};

export default React.memo(ServiceProvider);
